export async function captureErrorContext(_ref) {
  let {
    error,
    source
  } = _ref;
  const messages = Array.isArray(error?.userFriendlyMessages) ? error.userFriendlyMessages.join('; ') : error?.message || String(error);
  const context = {
    message: messages,
    stack: error?.stack || null,
    url: window.location.href,
    route: window.location.pathname,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    source
  };
  let screenshotFile = null;
  try {
    const html2canvas = (await import('html2canvas')).default;
    const canvas = await html2canvas(document.body, {
      ignoreElements: el => el.closest('[data-redact-screenshot]') !== null
    });
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (blob) {
      screenshotFile = new File([blob], 'error-screenshot.png', {
        type: 'image/png'
      });
    }
  } catch (e) {
    console.warn('[error report] screenshot capture failed:', e);
  }
  return {
    context,
    screenshotFile
  };
}
export function buildPrefill(context) {
  return {
    title: `Error on ${document.title || context.url}`,
    report_type: 'bug',
    description: [`Error: ${context.message}`, context.stack ? `\nStack trace:\n${context.stack}` : '', `\nURL: ${context.url}`, `Timestamp: ${context.timestamp}`, `Browser: ${context.userAgent}`].join('\n')
  };
}